import ReoptimizedLineupsViewInterface from './reoptimized-lineups-view-interface';
import LateswapCsvLineupInterface from 'src/components/organisms/late-swap/services/lineup-view/lateswap-csv-lineup-interface';
import LateswapCsvPlayerInterface from 'src/components/organisms/late-swap/services/player-view/lateswap-csv-player-interface';

export class DraftkingsReoptimizedLineupsView implements ReoptimizedLineupsViewInterface {
    makeView(csvData: string[][], lateswapCsvLineups: LateswapCsvLineupInterface[]): string[][] {
        const view = csvData;

        if (isEmpty(lateswapCsvLineups)) {
            return view;
        }

        lateswapCsvLineups.map((lateswapCsvLineup, index) => {
            const lineupCells = lateswapCsvLineup.getDetails();

            lateswapCsvLineup.getPlayers().map((player) => lineupCells.push(this.getPlayerCellView(player)));

            const rowNumber = 1 + index;

            lineupCells.map((lineupCell, index) => {
                view[rowNumber][index] = lineupCell;
            });
        });

        return view;
    }

    private getPlayerCellView(lateswapCsvPlayer: LateswapCsvPlayerInterface): string {
        // @ts-ignore
        const {name = ''} = lateswapCsvPlayer.getPlayer();

        return `${name} (${lateswapCsvPlayer.getExternalId()})`;
    }
}
